import {IMedicalSpecialty} from '@app/shared/models/medical-specialty.model';
import {createAction, props} from '@ngrx/store';
import {ICity} from 'src/app/shared/models/city.model';
import {ICountry} from 'src/app/shared/models/country.model';
import {IRegion} from 'src/app/shared/models/region.model';
import {IPhysicianSignUpRequest} from '../models/sign-up-request.model';

export enum SignUpActions {
  LoadCountries = '[SignUp component] signup page country',
  LoadCountriesFromInstitutionsSettings = '[InstitutionsSettings component] Institutions Settings page country',
  LoadCountriesSuccess = '[SignUp effect] load counties success',
  LoadRegions = '[SignUp component] signup page region',
  LoadRegionsFromInstitutionsSettings = '[InstitutionsSettings component] InstitutionsSettings page region',
  LoadRegionsSuccess = '[SignUp effect] load region success',
  LoadCities = '[SignUp component] signup page cities',
  LoadCitiesFromInstitutionsSettings = '[InstitutionsSettings component] InstitutionsSettings page cities',
  LoadCitiesSuccess = '[SignUp effect] load cities success',
  ResetCities = '[SignUp component] Reset cities',
  LoadMedicalSpecialties = '[SignUp component] signup page medical specialties',
  LoadMedicalSpecialtiesSuccess = '[SignUp effect] load medical specialties success',
  SignUpRequest = '[Signup Component] Signup request',
  SignUpSuccess = '[Signup Effects] Signup Success',
  SignUpFailure = '[Signup Effects] Signup Failure',
  ResendLink = '[ExpiredToken Component] resend confirmation link',
  ResendLinkSuccess = '[Signup Effects] resend confirmation link success',
  ResendLinkFailure = '[Signup Effects] resend confirmation link failure',
  GetReCaptchaToken = '[SignUpRequest Component] get recaptcha token',
  GetReCaptchaTokenSuccess = '[Signup Effects] get recaptcha token success',
  GetReCaptchaTokenFailure = '[Signup Effects] get recaptcha token failure',
  GetCaptchaResponse = '[Signup Effects] get captcha response',
  GetCaptchaResponseSuccess = '[Signup Effects] get captcha response success',
  GetCaptchaResponseFailure = '[Signup Effects] get captcha response failure',
  ResetCaptchaFromSignupEffects = '[Signup Effects] reset captcha token',
  ResetCaptchaFromSignupRequestComponent = '[SignUpRequest Component] reset captcha token',
}

export const loadCountries = createAction(SignUpActions.LoadCountries);
export const loadCountriesFromInstitutionsSettings = createAction(SignUpActions.LoadCountriesFromInstitutionsSettings);
export const loadCountriesSuccess = createAction(SignUpActions.LoadCountriesSuccess, props<{countries: ICountry[]}>());
export const loadRegions = createAction(SignUpActions.LoadRegions, props<{countryId: number}>());
export const loadRegionsFromInstitutionsSettings = createAction(
  SignUpActions.LoadRegionsFromInstitutionsSettings,
  props<{countryId: number}>()
);
export const loadRegionsSuccess = createAction(SignUpActions.LoadRegionsSuccess, props<{regions: IRegion[]}>());
export const loadCities = createAction(SignUpActions.LoadCities, props<{countryId: number; regionId: number}>());
export const loadCitiesFromInstitutionsSettings = createAction(
  SignUpActions.LoadCitiesFromInstitutionsSettings,
  props<{countryId: number; regionId: number}>()
);
export const loadCitiesSuccess = createAction(SignUpActions.LoadCitiesSuccess, props<{cities: ICity[]}>());
export const resetCities = createAction(SignUpActions.ResetCities);
export const loadMedicalSpecialties = createAction(SignUpActions.LoadMedicalSpecialties);
export const loadMedicalSpecialtiesSuccess = createAction(
  SignUpActions.LoadMedicalSpecialtiesSuccess,
  props<{medicalSpecialties: IMedicalSpecialty[]}>()
);
export const signUpRequest = createAction(SignUpActions.SignUpRequest, props<{request: IPhysicianSignUpRequest}>());
export const signUpSuccess = createAction(SignUpActions.SignUpSuccess);
export const signUpFailure = createAction(SignUpActions.SignUpFailure, props<{reason: string}>());
export const resendLink = createAction(SignUpActions.ResendLink, props<{email: string}>());
export const resendLinkSuccess = createAction(SignUpActions.ResendLinkSuccess);
export const resendLinkFailure = createAction(SignUpActions.ResendLinkFailure);

export const getRecaptchaToken = createAction(SignUpActions.GetReCaptchaToken);
export const getRecaptchaTokenSuccess = createAction(
  SignUpActions.GetReCaptchaTokenSuccess,
  props<{recaptchaToken: string}>()
);
export const getRecaptchaTokenFailure = createAction(SignUpActions.GetReCaptchaTokenFailure);
export const getCaptchaResponse = createAction(SignUpActions.GetCaptchaResponse, props<{token: string}>());

export const getCaptchaResponseSuccess = createAction(
  SignUpActions.GetCaptchaResponse,
  props<{captchaResponse: boolean}>()
);
export const getCaptchaResponseFailure = createAction(SignUpActions.GetCaptchaResponse);

export const resetCaptchaFromSignupEffects = createAction(SignUpActions.ResetCaptchaFromSignupEffects);

export const resetCaptchaFromSignupRequestComponent = createAction(
  SignUpActions.ResetCaptchaFromSignupRequestComponent
);

export type resendTokenLink = ReturnType<typeof resendLink>;
